import { ConsumablePart } from "utils/robot/consumablePart";


/**
 * 消耗品パーツが交換間近か判定する。
 * - 条件: 最大使用可能時間の 80% 以上
 */
export const hasWarningConsumablePart = (part: ConsumablePart): boolean => {
  return part.max * 0.8 < part.usage;
};